
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/register",
      function () {
        return require("private-next-pages/courses/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/register"])
      });
    }
  